module.exports = __webpack_public_path__ + "static/media/login-logo.5abd9c9c.svg";